import { render } from "./UpdateDeliveryApp.vue?vue&type=template&id=a2e55718"
import script from "./UpdateDeliveryApp.vue?vue&type=script&lang=js"
export * from "./UpdateDeliveryApp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__